import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  createCompany as createCompanyApi,
  loadCompanies as loadCompaniesApi,
  updateCompany as updateCompanyApi
} from '../api'

export const loadCompanies = createAsyncThunk('company/loadCompanies', async (params, { rejectWithValue }) => {
  try {
    const response = await loadCompaniesApi(params)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const createCompany = createAsyncThunk('company/createCompany', async ({ data }, { rejectWithValue }) => {
  try {
    const response = await createCompanyApi(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const updateCompany = createAsyncThunk('company/updateCompany', async ({ data, id }, { rejectWithValue }) => {
  try {
    const response = await updateCompanyApi(data, id)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

const initialState = {
  companies: [],
  approvedCompanies: [],
  rejectedCompanies: [],
  activeIndex: 0,
  currentCompany: null,
  newCompanyModalVisibility: false,
  createdSuccessModalVisibility: false,
  editCompanyModalVisibility: false,
  updatedSuccessModalVisibility: false,
  errorsFromServer: { new: null, edit: null },
}

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompanies: (state, action) => {
      state.companies = action.payload
    },
    setActiveIndex: (state, action) => {
      state.activeIndex = action.payload
    },
    setCurrentCompany: (state, action) => {
      state.currentCompany = action.payload
    },
    setEditCompanyModalVisibility: (state, action) => {
      state.editCompanyModalVisibility = !!action.payload
    },
    setUpdatedSuccessModalVisibility: (state, action) => {
      state.updatedSuccessModalVisibility = !!action.payload
    },
    clearErrorsFromServer: (state, action) => {
      state.errorsFromServer[action.payload] = null
    },
    setCreatedSuccessModalVisibility: (state, action) => {
      state.createdSuccessModalVisibility = !!action.payload
    },
    setNewCompanyModalVisibility: (state, action) => {
      state.newCompanyModalVisibility = !!action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadCompanies.fulfilled, (state, { payload }) => {
      state.companies = payload.companies
      state.approvedCompanies = state.companies.filter((company) => company.status === 'approved')
      state.rejectedCompanies = state.companies.filter((company) => company.status === 'rejected')
    })

    builder.addCase(updateCompany.fulfilled, (state, { payload }) => {
      state.editCompanyModalVisibility = false
      state.updatedSuccessModalVisibility = true
    })
    builder.addCase(updateCompany.rejected, (state, { payload }) => {
      state.errorsFromServer.edit = payload.error
    })
    builder.addCase(createCompany.fulfilled, (state, { payload }) => {
      state.createdSuccessModalVisibility = true
    })
    builder.addCase(createCompany.rejected, (state, { payload }) => {
      state.errorsFromServer.new = payload.error
    })
  },
})

export const {
  setCompanies,
  setActiveIndex,
  setCurrentCompany,
  setNewCompanyModalVisibility,
  setCreatedSuccessModalVisibility,
  setEditCompanyModalVisibility,
  setUpdatedSuccessModalVisibility,
  clearErrorsFromServer,
} = companySlice.actions

export const companyReducer = companySlice.reducer
